import { render, staticRenderFns } from "./instagramAuth.vue?vue&type=template&id=68ec332e"
import script from "./instagramAuth.vue?vue&type=script&lang=js"
export * from "./instagramAuth.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports